import React, { useState, useEffect } from 'react';
import './Sidebar.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

function Sidebar({ user, onLogout, currentPage, onNavigate, isOpen, onToggle }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    if (onToggle) {
      onToggle();
    }
  };

  const menuItems = [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: 'bi-house-door-fill',
      roles: ['admin', 'kurir']
    },
    {
      id: 'pengiriman',
      label: 'Data Pengiriman',
      icon: 'bi-box-seam',
      roles: ['admin']
    },
    {
      id: 'status-pengiriman',
      label: 'Status Pengiriman',
      icon: 'bi-truck',
      roles: ['admin', 'kurir']
    },
    {
      id: 'kelolaakun',
      label: 'Kelola Akun',
      icon: 'bi-people-fill',
      roles: ['admin']
    }
  ];

  const filteredMenu = menuItems.filter(item => 
    item.roles.includes(user.role)
  );

  return (
    <>
      {isOpen && isMobile && (
        <div 
          className="sidebar-overlay active"
          onClick={toggleSidebar}
        />
      )}

      <div className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
     
        <div className="sidebar-user-header">
          <div className="sidebar-user-info">
            <div className="sidebar-avatar">
              {user.nama.charAt(0).toUpperCase()}
            </div>
            {isOpen && (
              <div className="sidebar-user-details">
                <h3>Hi, {user.nama}</h3>
                <span className="sidebar-user-role">{user.role}</span>
              </div>
            )}
          </div>
          <button 
            className="sidebar-toggle"
            onClick={toggleSidebar}
            title={isOpen ? 'Tutup Sidebar' : 'Buka Sidebar'}
          >
            {isOpen ? '✕' : '☰'}
          </button>
        </div>

        <nav className="sidebar-nav">
          <ul className="sidebar-menu">
            {filteredMenu.map((item) => (
              <li key={item.id}>
                <button
                  className={`sidebar-menu-item ${currentPage === item.id ? 'active' : ''}`}
                  onClick={() => {
                    onNavigate(item.id);
                    if (isMobile) {
                      toggleSidebar();
                    }
                  }}
                  title={!isOpen ? item.label : ''}
                >
                  <span className="sidebar-icon">
                    <i className={item.icon} />
                  </span>
                  {isOpen && <span className="sidebar-label">{item.label}</span>}
                </button>
              </li>
            ))}
          </ul>
        </nav>
        <div className="sidebar-footer">
          <button 
            className="sidebar-logout"
            onClick={onLogout}
            title={!isOpen ? 'Logout' : ''}
          >
            <span className="sidebar-icon">
              <i className="bi-box-arrow-right" />
            </span>
            {isOpen && <span className="sidebar-label">Logout</span>}
          </button>
        </div>
      </div>
    </>
  );
}

export default Sidebar;